import React, { useCallback, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import { ImpactSummaryHandler } from './utils';
import {
  IndicatorByService,
  IndicatorSectionKey,
  IndicatorWithUpdate,
} from '../../../ReportBuilder/Components/ImpactIndicator/utils';
import IndicatorCardDetails from '../../../ReportBuilder/Components/ImpactIndicator/IndicatorCardDetails';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

export interface ImpactSummaryEditComponentProps {
  reportId: number;
  item: IndicatorWithUpdate;
  indicators: IndicatorByService;
  sectionKey: IndicatorSectionKey;
  itemKey: keyof IndicatorWithUpdate;
}

const noOp = () => null;
const StyledDiv = styled.div`
  position: relative;
  max-width: 560px;
  margin-top: ${SPACERS.large};
  margin-left: auto;
  margin-right: auto;
  .indicator {
    background-color: ${COLORS.whiteBase};
  }
  .delete-button-wrapper {
    text-align: center;
  }
  .guide-example {
    margin-top: 0;
  }
`;

const ImpactSummaryEditComponent = React.forwardRef<
  ImpactSummaryHandler,
  ImpactSummaryEditComponentProps
>(({ indicators, sectionKey, item, reportId }, forwardRef) => {
  const [updatedText, setUpdatedText] = useState<string>(
    item.updatedText || '',
  );

  useImperativeHandle(forwardRef, () => ({
    answer: () => ({
      answer: updatedText,
      errorText: updatedText
        ? undefined
        : 'Please add a valid indicator description.',
    }),
  }));

  const handleIndicatorTextUpdate = useCallback(
    (_sectionKey: IndicatorSectionKey, text: string) => {
      setUpdatedText(text);
    },
    [setUpdatedText],
  );

  item.lockDelete = true;

  return (
    <StyledDiv>
      <IndicatorCardDetails
        programName="your program"
        reportPeriod={{
          card: 'customYear',
          startDate: undefined,
          endDate: undefined,
        }}
        handleIndicatorSeenUpdate={noOp}
        handleIndicatorTextUpdate={handleIndicatorTextUpdate}
        index={0}
        isReportPassed={true}
        indicator={item}
        reportId={reportId}
        sectionKey={sectionKey}
        maxWidth={560}
        className="indicator"
        intermediaries={undefined}
        beneficiaryTerm={undefined}
        serviceGoal={undefined}
        serviceType={undefined}
      />
    </StyledDiv>
  );
});

export default ImpactSummaryEditComponent;
